import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "phoneWithHand",
    iconColor: "white",
    text: "Easy onboarding\nof services",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "workflow",
    iconColor: "white",
    text: "Agile workflow with easy \ntesting capabilities",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithCloud",
    iconColor: "white",
    text: "Access to network \nservices using CAMARA \nAPIs",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "boxWithGear",
    iconColor: "white",
    text: "Publish into\nApp marketplace",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_IEAM_1 = {
  title: "Easy Provider Onboarding",
  titleNumber: "1.",
  text: "Provides platform for application providers to easily onboard their \n application into the application marketplace.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ENG_103"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_101"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Introduction_02.png",
  demoButtons: [
    {
      label: "PROVIDER DEMO",
      onClick: () => {
        setPreviousPage("ENG_102");
        setCurrentPage("ENG_105");
      },
      endIcon: "play",
    },
    {
      label: "ENTERPRISE DEMO",
      onClick: () => {
        setPreviousPage("ENG_102");
        setCurrentPage("ENG_111");
      },
      endIcon: "play",
    },
    {
      label: "AI ASSISTED DEMO",
      onClick: () => {
        setPreviousPage("ENG_102");
        setCurrentPage("ENG_116");
      },
      endIcon: "play",
    },
  ],
};
